import React from 'react';
import { useTranslation } from 'react-i18next';
import { FaLayerGroup, FaExpandArrowsAlt, FaRocket, FaSyncAlt, FaUsers, FaPlug } from 'react-icons/fa';
import AnimateOnScroll from './AnimateOnScroll';

const items = [
  { icon: <FaLayerGroup size={16} />, key: 'item1' },
  { icon: <FaExpandArrowsAlt size={16} />, key: 'item2' },
  { icon: <FaRocket size={16} />, key: 'item3' },
  { icon: <FaSyncAlt size={16} />, key: 'item4' },
  { icon: <FaUsers size={16} />, key: 'item5' },
  { icon: <FaPlug size={16} />, key: 'item6' },
];

export default function Deployment() {
  const { t } = useTranslation();

  return (
    <section className="py-20 bg-white" id="deployment">
      <div className="container">
        <AnimateOnScroll>
          <div className="text-center mb-10 max-w-2xl mx-auto">
            <p className="t-h1">{t('Deployment.label')}</p>
            <h2 className="t-h2">{t('Deployment.title')}</h2>
            <p style={{ color: '#6b7280', lineHeight: 1.7, fontSize: '0.95rem' }}>
              {t('Deployment.intro')}
            </p>
          </div>
        </AnimateOnScroll>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 max-w-4xl mx-auto mb-12">
          {items.map((item, i) => (
            <AnimateOnScroll key={i} animation="fadeUp" delay={i * 60}>
              <div
                className="p-4 rounded-xl border flex items-center gap-3"
                style={{ borderColor: '#e5e7eb' }}
              >
                <div
                  className="w-9 h-9 rounded-lg flex items-center justify-center flex-shrink-0"
                  style={{ background: '#f0f2ff', color: '#010C66' }}
                >
                  {item.icon}
                </div>
                <p style={{ color: '#374151', fontSize: '0.85rem', fontWeight: 500 }}>
                  {t(`Deployment.${item.key}`)}
                </p>
              </div>
            </AnimateOnScroll>
          ))}
        </div>

        <AnimateOnScroll animation="fadeUp" delay={150}>
          <div
            className="max-w-3xl mx-auto rounded-2xl p-6"
            style={{ background: '#f8f9fe', border: '1px solid #e5e7eb' }}
          >
            <h3
              className="font-bold mb-2"
              style={{ fontFamily: '"Wix Madefor Display", sans-serif', fontSize: '1rem', color: '#010C66' }}
            >
              {t('Deployment.edgeTitle')}
            </h3>
            <p style={{ color: '#6b7280', lineHeight: 1.7, fontSize: '0.875rem' }}>
              {t('Deployment.edgeText')}
            </p>
          </div>
        </AnimateOnScroll>
      </div>
    </section>
  );
}
